
import { Component, Vue } from "vue-property-decorator";
import { RegisterRouter } from "@root/core/router";
import { toEnumInterface } from "@root/core";
import { BaseView } from "@root/components";
import { ProjectView } from "@/views/project-view";

@Component
export default class Form extends ProjectView {
    get window() {
        return window;
    }
}
